<template>
    <div id="amap"></div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
  name: 'AMapComponent',
  props: {
    areaList: {
      type: Array,
      default: () => [],
    },
    onSelectedArea: {
      type: Function,
      default: () => {},
    },
    onSelectedAreaPoint: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      AMap: null,
      map: null,
      infoWindow: null,
      marker1:null,
      marker2:null,
      marker3:null,
      marker4:null,
      baNo:null,
    };
  },
  created() {
    window._AMapSecurityConfig = {
      securityJsCode: '39e76f5a3ec1d2f9745aea620db39d99',
    };
  },
  mounted() {
    this.initAMap();
  },
  methods: {
    initAMap: function (callback) {
      const that = this;
      if (that.AMap) {
        callback && callback();
        return;
      }

      AMapLoader.load({
        key: '82a887f05523b4963481375e0fcffd05', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Geocoder', 'AMap.Polygon', 'AMap.InfoWindow','AMap.ToolBar'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          that.AMap = AMap;
          that.map = new AMap.Map('amap', {
            zoom: 12, //级别
            center: [118.103886046, 24.4892306125], //中心点坐标
            viewMode: '3D', //使用3D视图
          });
          that.infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(16, 0) });
          that.map.addControl(new AMap.ToolBar( { position: {top:'10px',right:'10px'}}));
          callback && callback();
        })
        .catch((e) => {
          console.error(e);
        });
    },
    backToArea(){
        let that = this;
        that.removeMarkers(2);
        if(that.marker1==null){
          that.initAMapWithData();
        }
        const map = that.map;
        map.setZoom(12);
        map.setCenter([118.103886046, 24.4892306125]);
      },
    initAMapWithData() {
      const that = this;

      const callback = () => {
        that.$nextTick(() => {
          const areaList = that.areaList;

          that.initPolygon(areaList);

          that.initText(areaList);
        });
      };

      that.initAMap(callback);
    },
    initPolygon(areaList) {
      const that = this;
      const AMap = that.AMap;
      const map = that.map;

      const polygons = areaList.map((item) => {
        const polygon = new AMap.Polygon({
          path: item.gdFenceData,
        });

        polygon.on('click', () => {
          that.setZoomAndCenter(item.gdFenceData[0]);
          that.onSelectedArea(item.baNo);
        });

        return polygon;
      });

      map.add(polygons);
    },
    initText(areaList) {
      const that = this;
      const AMap = that.AMap;
      const map = that.map;
      const texts = areaList.map(({ gdFenceData, baName, baNo }) => {
        // 获取多边形最右侧的点
        const [lng, lat] = gdFenceData.reduce((prev, curr) => {
          return prev[0] > curr[0] ? prev : curr;
        });

        const text = new AMap.Text({
          text: baName,
          anchor: 'center', // 设置文本标记锚点
          cursor: 'pointer',
          style: {
            padding: '0 .75rem',
            'border-radius': '.25rem',
            'background-color': 'white',
            'border-width': 0,
            'box-shadow': '0 2px 6px 0 rgba(114, 124, 245, .5)',
            'font-size': '20px',
          },
          position: [lng + 0.0001, lat + 0.0001],
          zIndex: 110,
        });

        text.on('click', () => {
          that.setZoomAndCenter(gdFenceData[0]);
          that.onSelectedArea(baNo);
        });

        return text;
      });

      map.add(texts);
      const markers = areaList.map(({ gdPointData, baName, baNo,total,inuse }) => {
        let position = [];
        const obj = gdPointData.find((item,index)=>{
          let cur = Math.floor(total/2);
          if(total>0 && index==cur){
            let cur = Math.ceil(index/2);
            position = [item.lng,item.lat];
          }
        });
        const markerContent = `
          <div class="custom-content-marker">
            <img alt="" src="https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png" />
            <span style="font-size:12px;line-height:22px;">${total || 0}</span>
          </div>
          `;

        const marker = new AMap.Marker({
          position,
          title:baName+'（摊位数：'+(total || 0)+' 经营中：'+(inuse || 0)+'）',
          content: markerContent,
        });
        let pos = [gdPointData[0].lng,gdPointData[0].lat]
        marker.on('click', () => {
          that.setZoomAndCenter(pos);
          that.onSelectedArea(baNo);
          that.removeMarkers(1);
        });
        return marker;
      });

    map.add(markers);
    that.marker1 = markers;
    that.marker4 = texts;
    },
    async initMarker(baNo) {
      const that = this;
      const AMap = that.AMap;
      const map = that.map;
      if(that.baNo != null){
        if(baNo != that.baNo) {
          map.remove(that.marker2);
          map.remove(that.marker3);
          that.marker2 = null;
          that.marker3 = null;
        }else{
          return;
        }
      }
      that.baNo = baNo;
      let areaList = that.areaList;
      let baInfo = that.areaList.find(item=> item.baNo === baNo);
      const e = await this.$axios.get(`/api/biz/query/boothListByBano/${baNo}`);
      const markers = baInfo.gdPointData.map((item) => {
        const markerContent = `
          <div class="custom-content-marker">
            <img alt="" src="https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png" />
            <span>${item.sortNo}</span>
          </div>
          `;

        const position = [item.lng, item.lat];

        const marker = new AMap.Marker({
          position,
          content: markerContent,
        });
        let curItem = e.data.data.find(val=> val.baPoint === item.sortNo);
        if(curItem != undefined){
          marker.on('click', () => {
            that.onSelectedAreaPoint(baInfo, curItem);
          });
        }

        return marker;
      });
      // const markers = e.data.data.map((item) => {
      //   const markerContent = `
      //     <div class="custom-content-marker">
      //       <img alt="" src="https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png" />
      //       <span>${item.baPoint}</span>
      //     </div>
      //     `;

      //   const position = [item.gdLng, item.gdLat];

      //   const marker = new AMap.Marker({
      //     position,
      //     content: markerContent,
      //   });

      //   let baInfo = this.areaList.find((item) => item.baNo === baNo);
      //   marker.on('click', () => {
      //     that.onSelectedAreaPoint(baInfo, item);
      //   });

      //   return marker;
      // });

      that.marker2 = markers;
      const texts = e.data.data.map((item) => {
        if(!item.boothName) return "";
        const text = new AMap.Text({
          text: item.leaseState>0?"第"+item.baPoint+"号，"+item.contactName:"第"+item.baPoint+"号，空闲",
          anchor: 'center', // 设置文本标记锚点
          cursor: 'pointer',
          style: {
            padding: '0 .75rem',
            'border-radius': '.25rem',
            'background-color': 'white',
            'border-width': 0,
            'box-shadow': '0 2px 6px 0 rgba(114, 124, 245, .5)',
            'font-size': '20px',
          },
          position: [Number(item.gdLng), Number(item.gdLat) + 0.00002],
          draggable:true,
          zIndex: 110,
        });
        text.on('click', () => {
          that.onSelectedAreaPoint(baInfo, item);
        });
        return text;
      });
      map.add(markers);
      map.add(texts);
      that.marker3 = texts;
    },
    setZoomAndCenter(lngLat) {
      const map = this.map;

      map.setCenter(lngLat);
      map.setZoom(20);
    },
    removeMarkers(num){
      let that = this;
      const map = that.map;
      if(num==1){
        if(that.marker1 != null){
          map.remove(that.marker1);
          map.remove(that.marker4);
          that.marker1 = null;
          that.marker4 = null;
        }
      }else{
        if(that.marker2 != null){
          map.clearMap();
          that.marker2 = null;
          that.marker3 = null;
          that.baNo = null;
        }
      }
    }
  },
};
</script>

<style>
#amap {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.custom-content-marker {
  position: relative;
  width: 30px;
  height: 41px;
}

.custom-content-marker img {
  width: 100%;
  height: 100%;
}

.custom-content-marker span {
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  text-align: center;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/AMapComponent.vue